import { gql } from '@apollo/client';

export const fetchRefundsInPPC = gql`
  query fetchRefundsInPPC($searchParams: RefundSearchParams!) {
    partnerRefunds(searchParams: $searchParams) {
      results {
        id
        creditNoteNumber
        transactionAccountId
        status
        arn
        createdDate
        sourceSystem
        total
        requestedBy
        shipTo {
          id
          fullName
          address {
            address1
            address2
            city
            state
            postalCode
            country
          }
        }
      }
    }
  }
`;
